import { render, staticRenderFns } from "./AppFooterLogin.vue?vue&type=template&id=71bbc2d6"
import script from "./AppFooterLogin.vue?vue&type=script&lang=js"
export * from "./AppFooterLogin.vue?vue&type=script&lang=js"
import style0 from "./AppFooterLogin.vue?vue&type=style&index=0&id=71bbc2d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports